export default __webpack_public_path__ + "static/machu-pichu-ca2506be9671e39549e1bba5f720c8b7.jpg";